import { cloneElement, Fragment, isValidElement, useId } from 'react'
import cx from 'classnames'

import { Label } from './Label'

export const Field = ({ children, className, error, helper, htmlFor, label }) => {
  const generatedId = useId()
  const hasSingleControl = isValidElement(children) && children.type !== Fragment
  const childId = children?.props?.id || htmlFor || generatedId
  const feedback = error || helper
  const feedbackId = `${childId}-feedback`
  const describedBy = [children?.props?.['aria-describedby'], feedback ? feedbackId : null].filter(Boolean).join(' ')

  return (
    <div className={cx('tw:mb-3 tw:grid tw:self-start tw:content-start tw:gap-1 tw:last:mb-0', className)}>
      {label && <Label htmlFor={hasSingleControl || htmlFor ? childId : undefined}>{label}</Label>}
      {hasSingleControl ? cloneElement(children, {
        ...(describedBy ? { 'aria-describedby': describedBy } : {}),
        ...(error ? { 'aria-invalid': true } : {}),
        id: childId,
      }) : children}
      {error
        ? <div className="ds-helper tw:text-status-danger-foreground" id={feedbackId} role="alert">{error}</div>
        : helper && <div className="ds-helper" id={feedbackId}>{helper}</div>}
    </div>
  )
}
